import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';

const filter = createFilterOptions();

export default function DropdownWithAddOption({ height, required, placeholder, options, setOptions, onSelect, valueField, selectedValueField, selected, validChar }) {
    const [value, setValue] = useState(null);
    const [input, setInput] = useState("");

    useEffect(() => {
        if (options?.length > 0 && selected) {
            setValue(options?.find(f => selected[(selectedValueField ?? valueField)] === f[valueField]));
        }
    }, [options, selected])

    const handleChange = (e) => {
        setInput(e.target.value);
        //e.target.value = e.target.value.toLowerCase().replace(/ /g, "_");
    };

    const handleKeyDown = (e) => {
        if (!validChar) return; // Skip validation if not required
        const { key } = e;
        const isFirstChar = input.length === 0;

        // Allow control keys
        const allowedControl = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
        if (allowedControl.includes(key)) return;

        // Regex for allowed characters
        //const validChar = /^[a-z0-9_]$/;
        if (!validChar.test(key)) {
            e.preventDefault();
            return;
        }

        // First character must be a-z
        if (isFirstChar && !/^[a-z]$/.test(key)) {
            e.preventDefault();
        }
    };

    return (
        <Autocomplete
            sx={{
                '& .MuiAutocomplete-inputRoot': {
                    padding: '0px',
                }
            }}
            slotProps={{
                paper: {
                    sx: {
                        fontSize: "13px", // Change font size of dropdown options
                    }
                },
                listbox: {
                    sx: {
                        fontSize: "13px", // Change font size of listbox items
                    }
                }
            }}
            value={value}
            onChange={(event, newValue) => {
                if (typeof newValue === 'string') {
                    // User typed a new value and hit Enter
                    setValue({ [valueField]: newValue });
                    onSelect({ [valueField]: newValue });
                    setOptions(prev => [...prev, { [valueField]: newValue }]);
                } else if (newValue && newValue.inputValue) {
                    // User selected "Add 'xyz'" option
                    setValue({ [valueField]: newValue.inputValue });
                    onSelect({ [valueField]: newValue.inputValue });
                    setOptions(prev => [...prev, { [valueField]: newValue.inputValue }]);
                } else {
                    setValue(newValue);
                    onSelect(newValue);
                }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params);
                const { inputValue } = params;
                const isExisting = options.some((option) => inputValue === option[valueField]);
                if (inputValue !== '' && !isExisting) {
                    filtered.push({
                        inputValue,
                        [valueField]: `➕ Add "${inputValue}"`,
                    });
                }

                return filtered;
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={options}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') return option;
                // Add "Add ..." option created dynamically
                if (option.inputValue) return option.inputValue;
                // Regular option
                return option[valueField];
            }}
            renderOption={(props, option) => <li {...props}>{option[valueField]}</li>}
            freeSolo
            renderInput={(params) => <TextField {...params} value={input} onChange={handleChange} onKeyDown={handleKeyDown} required={required} placeholder={placeholder} sx={{
                '& .MuiInputBase-root': {
                    padding: "0px",
                    height: height ?? "",
                    '&.Mui-focused fieldset': {
                        borderColor: 'none',
                        border: '0px',
                    },
                    fontSize: "13px",
                },
                "& .MuiOutlinedInput-root": {
                    backgroundColor: '#FFFFFF',
                    "& fieldset": {
                        borderColor: '#ccc'
                    },
                    '&:hover fieldset': {
                        borderColor: '#888',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#1976d2',
                    }
                }
            }} />}
        />
    );
}
// This component allows users to select from existing options or add a new option by typing it in and hitting Enter.